import React, { ReactNode } from 'react';
import Skeleton from 'react-loading-skeleton';
import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';
import { Cell, ICellProps } from './Cell';
import TableToggleButton from './TableToggleButton';

const ParentCellLayout = styled(Cell)`
  padding: 0;
`;

export const ParentCellInner = styled.div<ICellProps>`
  position: relative;
  flex-grow: 0;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: ${toRem(theme.table.cell.height)};
  padding: 0 ${toRem(theme.space.xl)};

  ${({ align }) =>
    align === 'center' &&
    css`
      justify-content: center;
    `}

  ${({ align }) =>
    align === 'right' &&
    css`
      && {
        justify-content: flex-end;
      }
    `}
`;

interface IParentCellProps extends ICellProps {
  children?: ReactNode;
  className?: string;
  dataLabel?: string;
}

export const ParentCell = ({ align, children, className, dataLabel, fontSize, maxWidth, minWidth, onClick, type, verticalAlign, ...rest }: IParentCellProps) => (
  <ParentCellLayout data-label={dataLabel} verticalAlign={verticalAlign} align={align} fontSize={fontSize} type={type} onClick={onClick} minWidth={minWidth} maxWidth={maxWidth} className={className} {...rest}>
    {children}
  </ParentCellLayout>
);

interface IParentCellDataButtonProps {
  label: string;
  onClick: (e?: MouseEvent) => void;
  data?: string[];
  isActive?: boolean;
  isLoading?: boolean;
}

export const ParentDataButton: React.FC<IParentCellDataButtonProps> = ({ data, label, onClick, isActive, isLoading }) =>
  isLoading ? <Skeleton width={77} /> : data && data.length >= 2 ? <TableToggleButton label={`${data.length} ${label}`} onClick={onClick} isActive={isActive} /> : <span>{data?.[0] || '--'}</span>;
